{
  "loading": "A carregar..."
}
